export function tratarMsgErroRequisicoesBack(AxiosError: any, mensagemDefault?: string) {
  if (AxiosError.response) {
    if (AxiosError.response.status === 400) {
      if (
        AxiosError?.response?.data &&
        typeof AxiosError.response.data === 'object' &&
        'message' in AxiosError.response.data
      ) {
        //Processo minerário não está mais vigente
        if (
          AxiosError.response.data.message.includes('O processo de lavra garimpeira não está com vigência iniciada')
        ) {
          return 'O processo minerário possui uma data de início de vigência futura ao da data da declaração';
        }

        //Processo minerário não é lavra garimpeira
        if (AxiosError.response.data.message.includes('O seguinte processo minerário não é de lavra garimpeira')) {
          return 'Processo não possui PLG outorgada';
        }

        if (AxiosError.response.data.message.includes(`A base de cálculo não pode ser menor que zero.`)) {
          return 'Erro ao calcular o valor da base de cálculo: o valor de deduções não pode ser maior do que valor da receita bruta';
        }
      }
    }
  }
  return mensagemDefault || 'Erro de validação. Verifique os campos informados';
}
